/**
 * @cesarvarela/indicators - Technical indicators for financial and time series analysis
 * 
 * A collection of technical indicators built with a functional, composable philosophy
 * using the compute pattern for consistent, type-safe transformations.
 */

// Type exports
export type { OHLCBar, VolumeBar, OHLCVBar, IndicatorField } from './types';

// Core compute function
export { compute, chain } from './compute';

// Basic indicators (work on any numeric field)
export { rsi, sma, ema, bollingerBands } from './indicators';

// MACD indicator (refactored with compute philosophy)
export { macd } from './indicators-macd';

// OHLC-specific indicators
export { donchian, atr, obv, obvMA } from './indicators-ohlc';

// Utility indicators and functions
export {
    slope,
    relativeChange,
    relativeValue,
    crossover,
    crossunder,
    crossoverValues,
    crossunderValues,
    zscore
} from './indicators-utils';

// Math utilities
export * as math from './math';